import React, { useEffect, useState } from "react";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
// /import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import axiosInstance from "../../../../../services/api/API";
import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";
import { buttonStyle, isFormValid } from "../../../../../../helpers/common";
import validations from "../../../../../../helpers/validations";

const EditDealer = () => {
  const [formData, setFormData] = useState({});
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [roledd, setRoledd] = useState([]);

  const [salesPersonOptions, setSalesPersonOptions] = useState([]);

  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const location = useLocation();
  const { data } = location.state || {};
  const Token = localStorage.getItem("authToken");
  const userType = localStorage.getItem("UserType");
  const [userTypedd, setUserTypedd] = useState([]);
  console.log(data, "BusinessPartnerID");
  const businessPartnerId = localStorage.getItem("business_partner_id");
  const BUSINESSPARTNERID = data?.business_partner_id;
  const [dealer, setDealer] = useState([]);

  useEffect(() => {
    userTypedropdown();
  }, []);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    roleDropdown();
  }, []);

  const roleDropdown = async () => {
    try {
      const payload = {
        business_partner_id:
          userType === "superadmin"
            ? formData?.business_partner_id
            : businessPartnerId,
      };

      const response = await axiosInstance.post("/role/ddlrole", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const roleOptions = data.map((role) => ({
        value: role.ID,
        label: role.NAME,
      }));
      setRoledd(roleOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    salesPersonDropdown();
  }, []);

  const salesPersonDropdown = async () => {
    try {
      const response = await axiosInstance.get("/salesperson/ddlSalesperson", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response?.data?.data;

      const dealerOptions = data.map((dealer) => ({
        value: dealer.sales_person_id,
        label: dealer.sales_person_name,
      }));

      setSalesPersonOptions(dealerOptions);
    } catch (error) {
      console.log(error);
    }
  };

  // const handleFormSubmit = async (formData) => {
  //   console.log("formdatadealer", formData);

  //   const errors = {};
  //   let isValid = true;
  //   DealerInputs.forEach((field) => {
  //     if (field.validation && field.validation.required) {
  //       if (!formData[field.name]) {
  //         errors[field.name] = "This field is required";
  //         isValid = false;
  //       }
  //     }
  //   });
  //   if (!isValid) {
  //     setValidationErrors(errors);
  //     return;
  //   }

  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "Do you want to update this dealer?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "No",

  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       try {
  //         setLoading(true);
  //         const payload = {
  //           dealer_name: formData.dealer_name,
  //           contact_no: formData.contact_no,
  //           dealer_address: formData.dealer_address,
  //           sales_person_id: formData.sales_person_name,
  //           email_id: formData.email_id,
  //           pan: formData.pan,
  //           gst: formData.gst,
  //           is_on_created: formData.is_on_created===true?1:0,
  //           is_partial_payment: formData.is_partial_payment === true ? 1 : 0,
  //           country_id: formData.country_id,
  //           state_id: formData.state_id,
  //           city_id: formData.city_id,
  //           dealer_pin_code: formData.pincode,
  //           status: formData.status === true ? 1 : 0,
  //           resetPass: formData.resetPass === true ? 1 : 0,
  //           remarks: formData.remarks || null,
  //         };

  //         const response = await axiosInstance.patch(`/dealer/update/${data.dealer_id}`, payload, {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${authToken}`,
  //           },
  //         });
  //         Swal.fire({
  //           title: "Success",
  //           text: "Dealer updated successfully!",
  //           icon: "success",
  //           confirmButtonText: "OK",
  //         }).then(() => {
  //           navigate(ROUTES_NAVIGATION.DEALERLIST);
  //         });

  //       } catch (error) {
  //         console.error('Error updating dealer:', error);
  //         const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
  //         Swal.fire({
  //           title: "Error",
  //           text: errorMessage,
  //           icon: "error",
  //           confirmButtonText: "OK",
  //         });
  //       } finally {
  //         setLoading(false);
  //       }
  //     }
  //     else if (result.dismiss === Swal.DismissReason.cancel) {
  //       Swal.fire({
  //         title: "Cancelled",
  //         text: "Your changes were not saved.",
  //         icon: "info",
  //         confirmButtonText: "OK",
  //       });
  //       setLoading(false)
  //     }
  //   });
  // };

  // const handleFormSubmit = async (formData) => {
  //   const urlToFile = async (url, filename, mimeType) => {
  //     console.log("url: ", url);
  //     console.log("filename: ", filename);
  //     console.log("mimeType: ", mimeType);

  //     const res = await fetch(url);
  //     console.log("res: ", res);

  //     const buffer = await res.arrayBuffer();
  //     return new File([buffer], filename, { type: mimeType });
  //   };

  //   console.log("formdatadealer", formData);

  //   const errors = {};
  //   let isValid = true;

  //   DealerInputs.forEach((field) => {
  //     if (field.validation && field.validation.required) {
  //       if (!formData[field.name]) {
  //         errors[field.name] = "This field is required";
  //         isValid = false;
  //       }
  //     }
  //   });

  //   if (!isValid) {
  //     setValidationErrors(errors);
  //     return;
  //   }

  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "Do you want to update this dealer?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "No",
  //     allowOutsideClick: false,
  //     allowEscapeKey: false,
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       try {
  //         setLoading(true);

  //         const payload = new FormData();

  //         payload.append("dealer_name", formData.dealer_name);
  //         payload.append("contact_no", formData.contact_no);
  //         payload.append("dealer_address", formData.dealer_address);
  //         // payload.append("sales_person_id", formData.sales_person_name);
  //         payload.append("email_id", formData.email_id);
  //         // payload.append("pan", formData.pan);
  //         // payload.append("gst", formData.gst);
  //         payload.append(
  //           "is_on_created",
  //           formData.is_on_created === true ? 1 : 0,
  //         );
  //         payload.append(
  //           "is_partial_payment",
  //           formData.is_partial_payment === true ? 1 : 0,
  //         );
  //         payload.append("country_id", formData.country_id);
  //         payload.append("state_id", formData.state_id);
  //         payload.append("city_id", formData.city_id);
  //         payload.append("dealer_pin_code", formData.pincode);
  //         payload.append("status", formData.status === true ? 1 : 0);
  //         payload.append("resetPass", formData.resetPass === true ? 1 : 0);
  //         payload.append("remarks", formData.remarks || "");

  //         if (formData.pan) {
  //           payload.append("pan", formData.pan);
  //         }
  //         // payload.append("pan", formData.pan);
  //         if (formData.gst) {
  //           payload.append("gst", formData.gst);
  //         }
  //         // Attach files only if available
  //         // if (formData.pan_image) {
  //         //   payload.append("pan_image", formData.pan_image);
  //         // }
  //         // if (formData.gst_image) {
  //         //   payload.append("gst_image", formData.gst_image);
  //         // }
  //         //  if (formData.trade_license) {
  //         //   payload.append("trade_license", formData.trade_license);
  //         // }
  //         // if (formData.bank_doc) {
  //         //   payload.append("bank_doc", formData.bank_doc);
  //         // }

  //         // 🖼️ PAN Image
  //         if (formData.pan_image) {
  //           if (formData.pan_image instanceof File) {
  //             payload.append("pan_image", formData.pan_image);
  //           } else if (typeof formData.pan_image === "string") {
  //             const file = await urlToFile(
  //               formData.pan_image,
  //               "pan_image.jpg",
  //               "image/jpeg",
  //             );
  //             payload.append("pan_image", file);
  //           }
  //         }

  //         // 🖼️ GST Image
  //         if (formData.gst_image) {
  //           if (formData.gst_image instanceof File) {
  //             payload.append("gst_image", formData.gst_image);
  //           } else if (typeof formData.gst_image === "string") {
  //             const file = await urlToFile(
  //               formData.gst_image,
  //               "gst_image.jpg",
  //               "image/jpeg",
  //             );
  //             payload.append("gst_image", file);
  //           }
  //         }

  //         // 🖼️ Trade License
  //         if (formData.trade_license) {
  //           if (formData.trade_license instanceof File) {
  //             payload.append("trade_license", formData.trade_license);
  //           } else if (typeof formData.trade_license === "string") {
  //             const file = await urlToFile(
  //               formData.trade_license,
  //               "trade_license.jpg",
  //               "image/jpeg",
  //             );
  //             payload.append("trade_license", file);
  //           }
  //         }

  //         // 🖼️ Bank Document
  //         if (formData.bank_doc) {
  //           if (formData.bank_doc instanceof File) {
  //             payload.append("bank_doc", formData.bank_doc);
  //           } else if (typeof formData.bank_doc === "string") {
  //             const file = await urlToFile(
  //               formData.bank_doc,
  //               "bank_doc.jpg",
  //               "image/jpeg",
  //             );
  //             payload.append("bank_doc", file);
  //           }
  //         }

  //         // PATCH API call with FormData
  //         const response = await axiosInstance.patch(
  //           `/dealer/update/${data.dealer_id}`,
  //           payload,
  //           {
  //             headers: {
  //               "Content-Type": "multipart/form-data",
  //               Authorization: `Bearer ${authToken}`,
  //             },
  //           },
  //         );

  //         Swal.fire({
  //           title: "Success",
  //           text: "Dealer updated successfully!",
  //           icon: "success",
  //           confirmButtonText: "OK",
  //           allowOutsideClick: false,
  //           allowEscapeKey: false,
  //         }).then(() => {
  //           navigate(ROUTES_NAVIGATION.DEALERLIST);
  //         });
  //       } catch (error) {
  //         console.error("Error updating dealer:", error);
  //         const errorMessage =
  //           error.response?.data?.message ||
  //           "An error occurred while processing your request.";
  //         Swal.fire({
  //           title: "Error",
  //           text: errorMessage,
  //           icon: "error",
  //           confirmButtonText: "OK",
  //         });
  //       } finally {
  //         setLoading(false);
  //       }
  //     } else if (result.dismiss === Swal.DismissReason.cancel) {
  //       Swal.fire({
  //         title: "Cancelled",
  //         text: "Your changes were not saved.",
  //         icon: "info",
  //         confirmButtonText: "OK",
  //       });
  //       setLoading(false);
  //     }
  //   });
  // };

  const handleFormSubmit = async (formData) => {
    console.log("formdatadealer", formData);

    const errors = {};
    let isValid = true;

    DealerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update this dealer?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);

          const payload = new FormData();

          payload.append("dealer_name", formData.dealer_name);
          payload.append("contact_no", formData.contact_no);
          payload.append("dealer_address", formData.dealer_address);
          payload.append("email_id", formData.email_id);
          payload.append(
            "is_on_created",
            formData.is_on_created === true ? 1 : 0,
          );
          payload.append(
            "is_partial_payment",
            formData.is_partial_payment === true ? 1 : 0,
          );
          payload.append("country_id", formData.country_id);
          payload.append("state_id", formData.state_id);
          payload.append("city_id", formData.city_id);
          payload.append("dealer_pin_code", formData.pincode);
          payload.append("status", formData.status === true ? 1 : 0);
          payload.append("resetPass", formData.resetPass === true ? 1 : 0);
          payload.append("remarks", formData.remarks || "");

          if (formData.pan) {
            payload.append("pan", formData.pan);
          }
          if (formData.gst) {
            payload.append("gst", formData.gst);
          }

          // ---------------------------------------------------------
          // FIXED FILE UPLOAD LOGIC:
          // Only append if it is a NEW file (instanceof File). 
          // If it's a string (URL), the server already has it, so skip it.
          // ---------------------------------------------------------

          // 🖼️ PAN Image
          if (formData.pan_image instanceof File) {
            payload.append("pan_image", formData.pan_image);
          }

          // 🖼️ GST Image
          if (formData.gst_image instanceof File) {
            payload.append("gst_image", formData.gst_image);
          }

          // 🖼️ Trade License
          if (formData.trade_license instanceof File) {
            payload.append("trade_license", formData.trade_license);
          }

          // 🖼️ Bank Document
          if (formData.bank_doc instanceof File) {
            payload.append("bank_doc", formData.bank_doc);
          }

          // PATCH API call with FormData
          const response = await axiosInstance.patch(
            `/dealer/update/${data.dealer_id}`, // Ensure 'data' is accessible here
            payload,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${authToken}`,
              },
            },
          );

          Swal.fire({
            title: "Success",
            text: "Dealer updated successfully!",
            icon: "success",
            confirmButtonText: "OK",
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then(() => {
            navigate(ROUTES_NAVIGATION.DEALERLIST);
          });
        } catch (error) {
          console.error("Error updating dealer:", error);
          const errorMessage =
            error.response?.data?.message ||
            "An error occurred while processing your request.";
          Swal.fire({
            title: "Error",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: "Cancelled",
          text: "Your changes were not saved.",
          icon: "info",
          confirmButtonText: "OK",
        });
        setLoading(false);
      }
    });
  };

  const fetchDealerEdit = async () => {
    try {
      const response = await axiosInstance.get(
        `/dealer/edit/${data.dealer_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
        },
      );
      const fetchedData = response.data.data;
      const transformedData = {
        business_partner_id: fetchedData.business_partner_id,
        dealer_code: fetchedData.dealer_code,
        dealer_name: fetchedData.dealer_name,
        dealer_desc: fetchedData.dealer_desc,
        contact_no: fetchedData.contact_no,
        dealer_address: fetchedData.dealer_address,
        sales_person_name: fetchedData.sales_person_id,
        email_id: fetchedData.email_id,
        tin: fetchedData.tin,
        pan: fetchedData.pan,
        gst: fetchedData.gst,
        sales_person_id: fetchedData.sales_person_id,
        // pincode:fetchedData.pincode,
        country_id: fetchedData.country_id,
        state_id: fetchedData.state_id,
        city_id: fetchedData.city_id,
        pincode: fetchedData.dealer_pin_code,
        // role_id: parseInt(fetchedData.role_id, 10),
        status: fetchedData.status === 1 ? true : false,
        is_on_created: fetchedData.is_on_created === 1 ? true : false,
        is_partial_payment: fetchedData.is_partial_payment === 1 ? true : false,
        //  pan_upload
        // gst_upload
        pan_image: fetchedData.pan_upload,
        gst_image: fetchedData.gst_upload,
        trade_license: fetchedData.trade_license,
        bank_doc: fetchedData.bank_doc,
      };
      setFormData(transformedData);
      setDealer(fetchedData);
      console.log(formData, "HSNCODE DATA");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDealerEdit();
  }, []);

  const DealerInputs = [
    // {
    //   name: "dealer_code",
    //   label: "Dealer Code",
    //   type: "text",
    //   // required: true,
    //   disabled:true,
    //   gridClass: "col-lg-4",
    //   placeholder:"Enter Dealer Code",

    // },
    {
      name: "dealer_name",
      label: "Dealer Name",
      placeholder: "Enter Dealer Name",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: validations.dealerName({ required: true }),
    },

    // {
    //   name: "sales_person_name",
    //   label: "Sales Person Name",
    //   placeholder: "Enter Sales Name",
    //   type: "dropdown",
    //   options: salesPersonOptions,
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true, },
    // },

    {
      name: "contact_no",
      label: "Contact No.",
      placeholder: "Enter Contact No.",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: validations.mobile({ required: true }),
    },
    {
      name: "dealer_address",
      label: "Dealer Address",
      placeholder: "Enter Dealer Address",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: validations.address({ required: true }),
    },
    {
      name: "email_id",
      label: "Email ID",
      placeholder: "Enter Email Address",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: validations.email({ required: true }),
    },

    {
      name: "pan",
      label: "PAN No.",
      type: "text",
      placeholder: "Enter Pan No.",
      validation: validations.pan({}),
      // required: true,
      gridClass: "col-lg-4",
    },
    // {
    //   name: "pan_image",
    //   label: "Pan Image",
    //   type: "file",
    //   // required: true,
    //   gridClass: "col-lg-4",
    //   // validation: { required: true },
    // },
    {
      name: "gst",
      label: "GST No.",
      type: "text",
      placeholder: "Enter GST No.",
      validation: validations.gst({}),
      // required: true,
      gridClass: "col-lg-4",
    },
    // {
    //   name: "gst_image",
    //   label: "GST Image",
    //   type: "file",
    //   // required: true,
    //   gridClass: "col-lg-4",
    //   // validation: { required: true },
    // },
    {
      name: "pincode",
      label: "Pin Code",
      placeholder: "Enter Pin Code",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: validations.pincode({ required: true }),
    },
    {
      name: "city",
      label: "City",
      placeholder: "City",
      type: "text",
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "state",
      label: "State",
      placeholder: "State",
      type: "text",
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "country",
      label: "Country",
      placeholder: "Country",
      type: "text",
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    ...(formData.status === false
      ? [
          {
            name: "remarks",
            label: "Remarks",
            placeholder: "Enter Remarks",
            type: "text",
            gridClass: "col-lg-4",
            // disabled: true,
          },
        ]
      : []),
    {
      name: "status",
      label: "Status",
      type: "toggle",
      gridClass: "col-lg-4",
    },
    {
      name: "resetPass",
      label: "Password Reset (123456)",
      type: "toggle",
      gridClass: "col-lg-4",
    },
    // {
    //   name: "is_on_created",
    //   label: "Is On Credit",
    //   type: "checkbox",
    //   required: true,
    //   // validation: { required: true },
    //   getValue: (value) => (value ? 1 : 0),
    //   gridClass: "col-lg-4",
    // },
    // {
    //   name: "is_partial_payment",
    //   label: "Partially Credit",
    //   type: "checkbox",
    //   required: true,
    //   // validation: { required: true },
    //   getValue: (value) => (value ? 1 : 0),
    //   gridClass: "col-lg-4",
    // },
    // {
    //   name: "actions",
    //   label: "Actions",
    //   type: "multiselectdropdown",
    //   required: true,
    //   options: [
    //     { label: "Edit", value: "Edit" },
    //     { label: "Delete", value: "Delete" },
    //   ],
    //   gridClass: "col-lg-4",
    // },
    {
      name: "pan_image",
      label: "Pan Image",
      type: "file",
      allowedExtensions: ["jpg", "jpeg", "png", "pdf"],
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
    },
    {
      name: "gst_image",
      label: "GST Image",
      type: "file",
      allowedExtensions: ["jpg", "jpeg", "png", "pdf"],
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
    },
    {
      name: "trade_license",
      label: "Trade License",
      type: "file",
      allowedExtensions: ["jpg", "jpeg", "png", "pdf"],
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
    },
    {
      name: "bank_doc",
      label: "Dealership Agreement",
      type: "file",
      allowedExtensions: ["jpg", "jpeg", "png", "pdf"],
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
    },
  ];

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
            <img src={backicon} alt="back" />
            <span className="backbtntitle">Edit Dealer</span>
          </div>
          <div className="form-container">
            <span className="cust-det-title mt-2 mb-2">
              Please Enter Dealer Details
            </span>
            <DynamicForm
              validateOnMount
              formConfig={DealerInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
          </div>
          <div className="btncontainer mt-3">
            <button
              onClick={() => {
                if (!isFormSubmitted) {
                  handleFormSubmit(formData); // Call handleFormSubmit if isFormSubmitted is false
                }
              }}
              disabled={
                !isFormValid(DealerInputs, formData, validationErrors) ||
                loading
              }
              className="submit-btn"
              style={buttonStyle(
                DealerInputs,
                formData,
                validationErrors,
                loading,
              )}
            >
              {loading ? "Processing..." : "Submit"}
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default EditDealer;
